// =============
import React, { Fragment, ReactNode, useContext, useEffect } from 'react';
import styles from './styles.module.css';
// import { LayoutContext } from '@/context/LayoutContext';

type SelectItemType = {
  list: { id: string; title: string; icon: ReactNode; onClick: (x: any) => void }[];
  className?: string;
  // onClick: (x: any) => void;
  selected?: string | number;
  id?: string;
  showItems?: string | number | null;
  setShowItems: React.Dispatch<React.SetStateAction<string | number | null>>;
  children?: ReactNode;
};

export default function SelectItems({
  list = [],
  className = '',
  // onClick,
  selected,
  id = 'selectItem',
  showItems,
  setShowItems,
  children = null,
}: SelectItemType) {
  // const { dir } = useContext(LayoutContext);
  console.log('id==', id, showItems);

  const checkIfClickedOutside = (e: MouseEvent) => {
    const target = e.target as Node; // cast EventTarget to Node

    if (showItems == id && document.getElementById(id)?.contains(target)) {
      setShowItems(id);
    } else {
      setShowItems(null);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, []);

  // ===========

  // useEffect(() => {
  //   const checkIfClickedOutside = (e: MouseEvent) => {
  //     const target = e.target as Node;
  //     const element = document.getElementById(id);

  //     if (element && !element.contains(target)) {
  //       setShowItems(null);
  //     }
  //   };

  //   document.addEventListener('mousedown', checkIfClickedOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', checkIfClickedOutside);
  //   };
  // }, [id, setShowItems]); // Remove showItems from deps if not needed

  // =============

  // // SelectItems.tsx — CORRECT VERSION
  // useEffect(() => {
  //   const handleClickOutside = (e: MouseEvent) => {
  //     const target = e.target as Node;
  //     const dropdown = document.getElementById(id);

  //     // Only close if:
  //     // 1. Dropdown exists
  //     // 2. Click was outside it
  //     // 3. (Optional) We don't need to check showItems here — parent controls visibility
  //     if (dropdown && !dropdown.contains(target)) {
  //       setShowItems(null);
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);

  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, [id, setShowItems]); // ← REMOVE showItems! Only id and setter

  return (
    <ul className={`${styles.container}   ${className}`}>
      <Fragment>
        {children ? (
          children
        ) : (
          <Fragment>
            {list?.map((item, index) => (
              <li
                key={id + item?.id}
                className={`${selected == item?.id ? styles.selected : ''} ${styles.item} `}
                onClick={() => {
                  item?.onClick(item);
                }}
              >
                {item?.icon}
                {item?.title && <span>{item?.title}</span>}
              </li>
            ))}
          </Fragment>
        )}
      </Fragment>
    </ul>
  );
}
